module.exports = __webpack_public_path__ + "media/svg/white-star-b378ff63.svg";